import PropTypes from "prop-types";

import { useAccountType } from "Payments/AddPaymentMethod/paymentMethodStateHooks";

import DropDown from "./Dropdown";

const options = [
  {
    id: "checking",
    label: "Checking",
  },
  {
    id: "savings",
    label: "Savings",
  },
];

export default function AccountTypeButton({ disabled }) {
  const [accountType, setAccountType] = useAccountType();

  const handleSelection = (option) => {
    setAccountType(option.id);
  };

  return (
    <DropDown
      name="Account Type"
      options={options}
      disabled={disabled}
      selected={accountType}
      handleSelection={handleSelection}
      tabindex={3}
    />
  );
}

AccountTypeButton.propTypes = {
  disabled: PropTypes.bool,
};
